import * as moment from 'moment';
import { Injectable } from '@angular/core';

import { UserModel } from '../../models/models';
import { ApiProvider } from '../api/api';

@Injectable()
export class UserProvider {
  private item: UserModel = null;

  constructor(
    private api: ApiProvider) {
  }

  Get() {
    return this.item;
  }

  Load(id: number) {
    return new Promise((resolve, reject) => {
      this.api.get(`user/${id}`).subscribe((res) => {
        const data = res.json();

        this.item = {
          _id: data.id,
          FirstName: data.first_name,
          LastName: data.last_name,
          Username: data.username,
          BodyHeight: data.body_height,
          BodyWeight: data.body_weight,
          BirthDate: data.birth_date
        } as UserModel;

        this.item.HeightDisplay = `${this.item.BodyHeight/12}' ${this.item.BodyHeight%12}"`;
        this.item.Age = moment().diff(this.item.BirthDate, 'years');

        resolve(this.item);
      });
    });
  }

  LoadMemo(id: number) {
    return new Promise((resolve, reject) => {
      this.api.get(`user/${id}/memo`).subscribe(res => {
        const data = res.json();
        this.item.Memo = data.memo;
        resolve(this.item);
      });
    });
  }

  SaveBodyWeight(id: number, body_weight: number) {
    this.api.post(`user/${id}/body_weight`, { body_weight: body_weight }).subscribe((res) => {
      this.item.BodyWeight = body_weight;
    });
  }

  SaveMemo(id: number, memo: string) {
    return new Promise((resolve, reject) => {
      this.api.post(`user/${id}/memo`, { memo: memo }).subscribe((res) => {
        this.item.Memo = memo;
        resolve();
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/user/user.ts